export default __webpack_public_path__ + "static/article-what-kind-of-shopper-are-you-fd74acaf0ee95a1a4212581b398277d9.jpg";